const Style = {
    // The reference's PageHeader: a flex row that stacks below sm.
    row: 'mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4',
    title: 'text-2xl font-semibold text-text-primary',
    actions: 'flex w-full shrink-0 items-center gap-2 sm:w-auto sm:justify-end',
};

export default Style;
